export const UPDATE_MAIL_TEMPLATE_FAILURE = 'UPDATE_MAIL_TEMPLATE_FAILURE';

export const updateMailTemplateFailure = error => ({
    type: UPDATE_MAIL_TEMPLATE_FAILURE,
    payload: error,
    error: true,
});
